export enum AuthenticationStrategy {
  ApplicationPassword = 'ApplicationPassword',
  JWT = 'JWT',
}
